var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80005 4.5002C1.80005 3.50608 2.60594 2.7002 3.60005 2.7002H10.8C11.7942 2.7002 12.6 3.50608 12.6 4.5002V13.5002C12.6 14.4943 13.4059 15.3002 14.4 15.3002H3.60005C2.60594 15.3002 1.80005 14.4943 1.80005 13.5002V4.5002ZM4.50005 5.4002H9.90005V9.0002H4.50005V5.4002ZM9.90005 10.8002H4.50005V12.6002H9.90005V10.8002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.3002H14.4C15.3942 6.3002 16.2 7.10608 16.2 8.1002V13.0502C16.2 13.7958 15.5956 14.4002 14.85 14.4002C14.1045 14.4002 13.5 13.7958 13.5 13.0502V6.3002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.b241f73bba5f74d9d229db367b98b9df.svg";
export { ForwardRef as ReactComponent };